var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8304 7.38729V15.0782C17.8304 17.0888 16.1876 18.7317 14.177 18.7317H7.24618C5.23558 18.7317 3.59277 17.0888 3.59277 15.0782V7.38729C3.59277 5.98968 4.3774 4.77187 5.52982 4.15889C5.9303 3.94638 6.42886 4.23244 6.42886 4.69014C6.42886 5.98968 7.49138 7.05219 8.79091 7.05219H12.6323C13.9318 7.05219 14.9943 5.98968 14.9943 4.69014C14.9943 4.23244 15.4847 3.94638 15.8934 4.15889C17.0458 4.77187 17.8304 5.98968 17.8304 7.38729Z",
    fill: "#6B6B6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6322 2.38525H8.79082C7.94081 2.38525 7.24609 3.0718 7.24609 3.92181V4.69009C7.24609 5.5401 7.93264 6.22664 8.78265 6.22664H12.6322C13.4822 6.22664 14.1688 5.5401 14.1688 4.69009V3.92181C14.1769 3.0718 13.4822 2.38525 12.6322 2.38525Z",
    fill: "#6B6B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDisable);
export default __webpack_public_path__ + "static/media/document-disable.10f9f82600da54ac0959b84c0bf5f196.svg";
export { ForwardRef as ReactComponent };